<template>
    <div>
        <apexchart width="100%" height="300" type="bar" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { baseOptions, rgba } from "./theme";
import { moneyCompact, isNum } from "@/utils/format";

// Financial statement figures arrive in millions of USD.
const fromMillions = (v) => (isNum(v) ? moneyCompact(Number(v) * 1e6, 1) : "—");

const STEPS = [
    { label: "Revenue", color: "#00AA6F" },
    { label: "COGS", color: "#F87171" },
    { label: "Gross profit", color: "#10B981" },
    { label: "Op. expenses", color: "#F87171" },
    { label: "Op. income", color: "#0EA5E9" },
    { label: "Non-op. income", color: "#94A3B8" },
    { label: "Taxes & other", color: "#F59E0B" },
    { label: "Net Income", color: "#047857" },
];

export default {
    name: "RevenueChart",
    components: { apexchart: VueApexCharts },
    props: {
        conservationChartData: { type: [Array, Object], default: () => [] },
    },
    computed: {
        series() {
            const list = Array.isArray(this.conservationChartData) ? this.conservationChartData : [];
            const values = list.map((p) => (isNum(p && p.y) ? Number(p.y) : 0));
            return [{ name: this.$t("Amount"), data: values }];
        },
        chartOptions() {
            const base = baseOptions();
            // Horizontal bars: eight labels never fit under columns in a half-width
            // card, but they read comfortably down the left side in any language.
            return {
                ...base,
                chart: { ...base.chart, type: "bar" },
                colors: STEPS.map((s) => s.color),
                plotOptions: { bar: { horizontal: true, distributed: true, borderRadius: 3, barHeight: "64%" } },
                legend: { show: false },
                grid: {
                    ...base.grid,
                    xaxis: { lines: { show: true } },
                    yaxis: { lines: { show: false } },
                },
                xaxis: {
                    categories: STEPS.map((s) => this.$t(s.label)),
                    tickAmount: 4,
                    axisTicks: { show: false },
                    axisBorder: { show: false },
                    labels: { formatter: fromMillions, style: { fontSize: "11px" } },
                },
                yaxis: {
                    labels: { maxWidth: 160, style: { fontSize: "12px", colors: rgba("ink-3") } },
                },
                tooltip: { ...base.tooltip, y: { formatter: fromMillions } },
            };
        },
    },
};
</script>
